import { Badge, Button, Group, Paper } from '@mantine/core';
import { Save, Languages } from 'lucide-react';
import { memo } from 'react';

interface TranslationActionsBarProps {
  totalKeys: number;
  filteredKeys: number;
  hasChanges: boolean;
  isPending: boolean;
  isPendingTranslate: boolean;
  onReset: () => void;
  onSaveOnly: () => void;
  onSaveAndTranslate: () => void;
}

export const TranslationActionsBar = memo(function TranslationActionsBar({
  totalKeys,
  filteredKeys,
  hasChanges,
  isPending,
  isPendingTranslate,
  onReset,
  onSaveOnly,
  onSaveAndTranslate,
}: TranslationActionsBarProps) {
  const isAnyPending = isPending || isPendingTranslate;

  return (
    <Paper shadow='sm' p='md' withBorder>
      <Group justify='space-between'>
        <Group>
          <Badge size='lg' variant='light'>
            {filteredKeys} / {totalKeys} chiavi
          </Badge>
          {hasChanges && (
            <Badge size='lg' color='orange' variant='filled'>
              Modifiche non salvate
            </Badge>
          )}
        </Group>
        <Group>
          {hasChanges && (
            <Button
              variant='light'
              color='gray'
              onClick={onReset}
              disabled={isAnyPending}
            >
              Annulla
            </Button>
          )}
          <Button
            leftSection={<Save size={16} />}
            onClick={onSaveOnly}
            disabled={!hasChanges || isAnyPending}
            loading={isPending}
            variant='light'
          >
            Salva
          </Button>
          <Button
            leftSection={<Languages size={16} />}
            onClick={onSaveAndTranslate}
            disabled={!hasChanges || isAnyPending}
            loading={isPendingTranslate}
          >
            Salva e Traduci
          </Button>
        </Group>
      </Group>
    </Paper>
  );
});
